import { render, staticRenderFns } from "./CollapseTextWithTooltip.vue?vue&type=template&id=aaf825b4&scoped=true"
import script from "./CollapseTextWithTooltip.vue?vue&type=script&lang=js"
export * from "./CollapseTextWithTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf825b4",
  null
  
)

export default component.exports